export default __webpack_public_path__ + "static/media/h1.fa7a5212.jpg";